import React from 'react';

import cx from 'classnames';

import styles from './styles.module.scss';

class Cell extends React.Component {
  constructor(props) {
    super(props);

  }

  render() {
    return (
      <div className={cx(styles.cell, this.props.className, styles[`column-${this.props.column}`], {
        [styles.empty]: this.props.empty
      })}>
        {this.props.children}
      </div>
    );
  }
}

Cell.defaultProps = {
  column: 1
};

export default Cell;    